<template>
  <div class="icon-selector">
    <el-popover
      placement="bottom"
      width="450"
      trigger="click"
      v-model="visible">
      <div class="icon-grid">
        <div class="icon-category" v-for="(category, categoryName) in iconCategories" :key="categoryName">
          <h4>{{ categoryName }}</h4>
          <div class="icon-list">
            <div 
              v-for="icon in category" 
              :key="icon" 
              class="icon-item" 
              :class="{ 'active': selectedIcon === icon }"
              @click="selectIcon(icon)">
              <i :class="icon"></i>
              <span class="icon-name">{{ icon }}</span>
            </div>
          </div>
        </div>
      </div>
      <el-input 
        slot="reference"
        v-model="selectedIcon" 
        placeholder="点击选择图标">
        <template slot="prepend">
          <i :class="selectedIcon || 'el-icon-picture-outline'"></i>
        </template>
        <el-button slot="append" icon="el-icon-search" @click.stop="visible = true">选择</el-button>
      </el-input>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'IconSelector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      selectedIcon: this.value,
      // Element UI 图标分类
      iconCategories: {
        '常用图标': [
          'el-icon-s-home',
          'el-icon-s-shop',
          'el-icon-s-marketing',
          'el-icon-s-goods',
          'el-icon-s-help',
          'el-icon-s-operation',
          'el-icon-s-platform',
          'el-icon-s-order',
          'el-icon-s-cooperation',
          'el-icon-s-ticket',
          'el-icon-s-grid',
          'el-icon-s-tools',
          'el-icon-s-data',
          'el-icon-s-custom',
          'el-icon-s-claim',
          'el-icon-s-finance',
          'el-icon-s-comment',
          'el-icon-s-flag',
          'el-icon-s-opportunity',
          'el-icon-s-release',
          'el-icon-s-promotion'
        ],
        '方向图标': [
          'el-icon-arrow-left',
          'el-icon-arrow-right',
          'el-icon-arrow-down',
          'el-icon-arrow-up',
          'el-icon-back',
          'el-icon-right',
          'el-icon-top',
          'el-icon-bottom',
          'el-icon-d-arrow-left',
          'el-icon-d-arrow-right',
          'el-icon-d-caret',
          'el-icon-caret-left',
          'el-icon-caret-right',
          'el-icon-caret-bottom',
          'el-icon-caret-top'
        ],
        '文件图标': [
          'el-icon-document',
          'el-icon-tickets',
          'el-icon-folder',
          'el-icon-folder-opened',
          'el-icon-folder-add',
          'el-icon-folder-remove',
          'el-icon-folder-delete',
          'el-icon-folder-checked',
          'el-icon-document-add',
          'el-icon-document-checked',
          'el-icon-document-delete',
          'el-icon-document-copy'
        ],
        '用户图标': [
          'el-icon-user',
          'el-icon-user-solid',
          'el-icon-avatar',
          'el-icon-male',
          'el-icon-female'
        ],
        '数据图标': [
          'el-icon-data-analysis',
          'el-icon-data-line',
          'el-icon-data-board',
          'el-icon-pie-chart',
          'el-icon-rank',
          'el-icon-trend-charts',
          'el-icon-histogram'
        ],
        '通用图标': [
          'el-icon-menu',
          'el-icon-setting',
          'el-icon-edit',
          'el-icon-delete',
          'el-icon-refresh',
          'el-icon-search',
          'el-icon-share',
          'el-icon-plus',
          'el-icon-minus',
          'el-icon-check',
          'el-icon-close',
          'el-icon-info',
          'el-icon-warning',
          'el-icon-question',
          'el-icon-error',
          'el-icon-success',
          'el-icon-star-on',
          'el-icon-star-off',
          'el-icon-view',
          'el-icon-hide',
          'el-icon-more',
          'el-icon-more-outline',
          'el-icon-phone',
          'el-icon-mobile-phone',
          'el-icon-bell',
          'el-icon-message',
          'el-icon-chat-dot-round',
          'el-icon-chat-line-round',
          'el-icon-chat-dot-square',
          'el-icon-chat-line-square',
          'el-icon-picture',
          'el-icon-picture-outline',
          'el-icon-picture-outline-round',
          'el-icon-camera',
          'el-icon-camera-solid',
          'el-icon-video-camera',
          'el-icon-video-camera-solid',
          'el-icon-location',
          'el-icon-location-outline',
          'el-icon-location-information',
          'el-icon-printer',
          'el-icon-date',
          'el-icon-time',
          'el-icon-odometer',
          'el-icon-crop',
          'el-icon-aim',
          'el-icon-switch-button',
          'el-icon-full-screen',
          'el-icon-copy-document',
          'el-icon-mic',
          'el-icon-stopwatch',
          'el-icon-medal',
          'el-icon-trophy',
          'el-icon-upload',
          'el-icon-download',
          'el-icon-first-aid-kit',
          'el-icon-smoking',
          'el-icon-no-smoking',
          'el-icon-shopping-cart',
          'el-icon-shopping-cart-full',
          'el-icon-shopping-cart-1',
          'el-icon-shopping-cart-2',
          'el-icon-shopping-bag',
          'el-icon-shopping-bag-1',
          'el-icon-shopping-bag-2',
          'el-icon-sold-out',
          'el-icon-sell',
          'el-icon-present',
          'el-icon-box',
          'el-icon-bank-card',
          'el-icon-money',
          'el-icon-coin',
          'el-icon-wallet',
          'el-icon-discount',
          'el-icon-price-tag'
        ]
      }
    }
  },
  watch: {
    value(val) {
      this.selectedIcon = val;
    },
    selectedIcon(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    selectIcon(icon) {
      this.selectedIcon = icon;
      this.visible = false;
    }
  }
}
</script>

<style scoped>
.icon-selector {
  width: 100%;
}

.icon-grid {
  max-height: 350px;
  overflow-y: auto;
  padding: 10px;
}

.icon-category {
  margin-bottom: 15px;
}

.icon-category h4 {
  margin: 5px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
}

.icon-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
}

.icon-item {
  width: 110px;
  height: 90px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid transparent;
  background-color: #f5f7fa;
}

.icon-item:hover {
  background-color: #ecf5ff;
  border-color: #c6e2ff;
}

.icon-item.active {
  background-color: #ecf5ff;
  border-color: #409EFF;
  color: #409EFF;
}

.icon-item i {
  font-size: 24px;
  margin-bottom: 8px;
}

.icon-name {
  font-size: 12px;
  word-break: break-all;
  text-align: center;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
